export default __webpack_public_path__ + "static/media/support.42dc5937.svg";